// extracted by mini-css-extract-plugin
export default {"content":"MessageRooms_content__HMpvG"};